import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "components/ui/data-table-column-header";
import { CnRow } from "./api/reports";
import { formatINR, formatWeight } from "lib/utils";

export const createCnColumns = (loadBranchCns: (booking_branch: string, branch_name: string) => void): ColumnDef<CnRow>[] => [
  {
    accessorKey: "branch_name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Branch Name" />
    ),
    cell: ({ row }) => (
      <div className="cursor-pointer hover:underline" onClick={() => loadBranchCns(row.original.booking_branch, row.original.branch_name)}>{row.original.branch_name}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "cn_count",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CN Count" />
    ),
    cell: ({ row }) => {
      const val = row.getValue("cn_count") as number;
      return (
        <div className="text-xs font-medium">{val}</div>
      );
    },
    enableSorting: true,
  },

  {
    accessorKey: "branch_value",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Value" />
    ),
    cell: ({ row }) => {
      const val = row.getValue("branch_value") as number;
      return (
        <div className="text-xs font-medium">₹ {formatINR(val)}</div>
      );
    },
    enableSorting: true,
  },

  {
    accessorKey: "actual_weight",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Actual Weight" />
    ),
    cell: ({ row }) => {
      const val = row.getValue("actual_weight") as number;
      return <div className="text-xs">{formatWeight(val)}</div>;
    },
    enableSorting: true,
  },

  {
    accessorKey: "charge_weight",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Charge Weight" />
    ),
    cell: ({ row }) => {
      const val = row.getValue("charge_weight") as number;
      return <div className="text-xs">{formatWeight(val)}</div>;
    },
    enableSorting: true,
  },
];
